import Swiper from "swiper/bundle";

const OverviewAwardsSlider = () => {
  const sliders = Array.from(document.querySelectorAll(".overview__awards"));
  if (sliders.length > 0) {
    sliders.forEach((slider) => {
      const initSlider = new Swiper(slider, {
        spaceBetween: 8,
        slidesPerView: 3,
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: slider.querySelector(".slider__pagination"),
          clickable: true,
          dynamicBullets: true,
        },
        navigation: {
          nextEl: slider.querySelector(".slider__next-btn"),
          prevEl: slider.querySelector(".slider__prev-btn"),
        },
        breakpoints: {
          560: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          767: {
            slidesPerView: 5,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 8,
          },
          1440: {
            slidesPerView: 5,
          },
        },
      });
    });
  }
};

export default OverviewAwardsSlider;
